// extracted by mini-css-extract-plugin
export default {"container":"Group_container__By+jK"};